import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Papa from 'papaparse';
import './App.css';

function App() {
  // Leaderboard states
  const [classLeaderboard, setClassLeaderboard] = useState([]);
  const [groupLeaderboard, setGroupLeaderboard] = useState([]);
  const [studentLeaderboard, setStudentLeaderboard] = useState([]);
  const [activeLeaderboardTab, setActiveLeaderboardTab] = useState('class');
  const [isPublicMode, setIsPublicMode] = useState(false);

  //full mark achievers  news ticker

  const [fullMarkAchievers, setFullMarkAchievers] = useState([]);
  // Classes management
  const [classes, setClasses] = useState([]);
  const [showClassModal, setShowClassModal] = useState(false);
  const [classForm, setClassForm] = useState({ name: '', accessCode: '' });
  const [editingClassId, setEditingClassId] = useState(null);
  // Student import states
  const [csvFile, setCsvFile] = useState(null);
  const [csvData, setCsvData] = useState([]);
  const [importMessage, setImportMessage] = useState('');
  // Bulk score entry states
  const [selectedBulkClass, setSelectedBulkClass] = useState('');
  const [bulkStudents, setBulkStudents] = useState([]);
  const [bulkScores, setBulkScores] = useState([]);
  const [showBulkScoreModal, setShowBulkScoreModal] = useState(false);
  const [bulkDate, setBulkDate] = useState('');
  // Existing states (admin, groups, students, etc.)
  const [selectedClass, setSelectedClass] = useState(null);
  const [accessCode, setAccessCode] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState('');
  const [groups, setGroups] = useState([]);
  const [showGroups, setShowGroups] = useState(false);
  const [students, setStudents] = useState([]);
  // Admin states
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const [adminUsername, setAdminUsername] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [adminError, setAdminError] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showAdminDashboard, setShowAdminDashboard] = useState(false);
  // Score Entry states
  const [selectedAdminClass, setSelectedAdminClass] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');
  const [selectedStudentId, setSelectedStudentId] = useState('');
  const [scores, setScores] = useState({
    noise_level: 5,
    equipment_care: 5,
    teamwork: 5,
    task_completion: 5,
    bonus: 0
  });
  const [sessionType, setSessionType] = useState('double');
  const [scoreDate, setScoreDate] = useState('');
  const [saveMessage, setSaveMessage] = useState('');
  // Student Import states
  const [studentNamesInput, setStudentNamesInput] = useState('');
  const [groupCreateMessage, setGroupCreateMessage] = useState('');
  // Edit states
  const [editingGroupId, setEditingGroupId] = useState(null);
  const [editingGroupName, setEditingGroupName] = useState('');
  const [editingStudentId, setEditingStudentId] = useState(null);
  const [editingStudentName, setEditingStudentName] = useState('');
  // Move Student states
  const [showMoveStudentModal, setShowMoveStudentModal] = useState(false);
  const [studentToMove, setStudentToMove] = useState(null);
  const [newMoveClass, setNewMoveClass] = useState('');
  const [newMoveGroup, setNewMoveGroup] = useState('');
  const [availableMoveGroups, setAvailableMoveGroups] = useState([]);
  // Super Admin states
  const [showSuperAdminLogin, setShowSuperAdminLogin] = useState(false);
  const [superUsername, setSuperUsername] = useState('');
  const [superPassword, setSuperPassword] = useState('');
  const [superError, setSuperError] = useState('');
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  // New: Dashboard view state
  const [activeView, setActiveView] = useState('leaderboard');

  // Fetch leaderboards
  useEffect(() => {
    fetchLeaderboards();
  }, []);

  // Persist admin login state
  useEffect(() => {
    const savedLogin = localStorage.getItem('adminLoggedIn');
    if (savedLogin === 'true') {
      setIsLoggedIn(true);
      setShowAdminDashboard(true);
      setActiveView('admin');
      setIsPublicMode(false);
    }
  }, []);

  const fetchLeaderboards = async () => {
    try {
      const classResponse = await axios.get('/api/leaderboard/class');
      setClassLeaderboard(classResponse.data);
      const groupResponse = await axios.get('/api/leaderboard/group');
      setGroupLeaderboard(groupResponse.data);
      const studentResponse = await axios.get('/api/leaderboard/student');
      setStudentLeaderboard(studentResponse.data);
    } catch (error) {
      console.error("Error fetching leaderboards:", error);
    }
  };

  const fetchFullMarkAchievers = async () => {
    try {
      const res = await axios.get('/api/full-mark-achievers');
      setFullMarkAchievers(res.data);
    } catch (err) {
      console.error("Failed to fetch full-mark achievers", err);
    }
  };

  // Inside your main useEffect
  useEffect(() => {
    fetchLeaderboards();
    fetchFullMarkAchievers();
    // Optional: refresh every 30 seconds
    const interval = setInterval(fetchFullMarkAchievers, 30000);
    return () => clearInterval(interval);
  }, []);


  // Fetch classes
  useEffect(() => {
    axios.get('/api/classes')
      .then(response => setClasses(response.data))
      .catch(error => console.error("Error fetching classes:", error));
  }, []);

  useEffect(() => {
    if (selectedAdminClass) {
      axios.get(`/api/groups/${selectedAdminClass}`)
        .then(response => setGroups(response.data))
        .catch(error => console.error("Error fetching groups:", error));
    }
  }, [selectedAdminClass]);

  // Functions
  const handleClassClick = (cls) => {
    setSelectedClass(cls);
    setAccessCode('');
    setError('');
    setShowModal(true);
    setGroups([]);
    setShowGroups(false);
    setIsPublicMode(false);
  };

  const handleAccessSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post('/api/verify-access-code', {
        className: selectedClass.name,
        accessCode: accessCode
      });
      if (response.data.success) {
        const groupsResponse = await axios.get(`/api/groups/${response.data.classId}`);
        setGroups(groupsResponse.data);
        setShowGroups(true);
        setShowModal(false);
        setActiveView('groups');
        setIsPublicMode(true);
        setSelectedClass({ name: response.data.className });
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    }
  };

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setAdminError('');
    try {
      const response = await axios.post('/api/admin/login', {
        username: adminUsername,
        password: adminPassword
      });
      if (response.data.success) {
        setIsLoggedIn(true);
        setShowAdminDashboard(true);
        setShowAdminLogin(false);
        setAdminUsername('');
        setAdminPassword('');
        setActiveView('admin');
        setIsPublicMode(false);
        localStorage.setItem('adminLoggedIn', 'true'); // ✅ Persist login
      }
    } catch (err) {
      setAdminError(err.response?.data?.error || 'Login failed');
    }
  };

  // Fetch students when group is selected
  const fetchStudents = (groupId) => {
    axios.get(`/api/students/${groupId}`)
      .then(response => setStudents(response.data))
      .catch(error => console.error("Error fetching students:", error));
  };

  const handleSaveScore = async () => {
    if (!selectedStudentId) return alert('Please select a student');
    try {
      const response = await axios.post('/api/scores', {
        studentId: selectedStudentId,
        noise_level: scores.noise_level,
        equipment_care: scores.equipment_care,
        teamwork: scores.teamwork,
        task_completion: scores.task_completion,
        bonus: scores.bonus,
        sessionType: sessionType,
        date: scoreDate || new Date().toISOString().split('T')[0]
      });
      if (response.data.success) {
        setSaveMessage('✅ Score saved successfully!');
        setScores({ 
          noise_level: 5, 
          equipment_care: 5, 
          teamwork: 5, 
          task_completion: 5, 
          bonus: 0 
        });
        setSessionType('double');
        setScoreDate('');
        setSelectedStudentId('');
        setTimeout(() => setSaveMessage(''), 3000);
        fetchLeaderboards();
      }
    } catch (err) {
      alert('Failed to save score: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleImportStudents = async () => {
    if (!selectedGroup) return alert('Please select a group');
    const names = studentNamesInput.split('\n').map(n => n.trim()).filter(n => n);
    if (names.length === 0) return alert('Please enter student names');
    try {
      const response = await axios.post('/api/import-students', {
        groupId: selectedGroup,
        studentNames: names
      });
      if (response.data.success) {
        setImportMessage(`✅ ${response.data.count} students imported!`);
        setStudentNamesInput('');
        if (selectedStudentId) fetchStudents(selectedGroup);
        setTimeout(() => setImportMessage(''), 3000);
        fetchLeaderboards();
      }
    } catch (err) {
      alert('Failed to import students: ' + (err.response?.data?.error || err.message));
    }
  };

  // Add single group
  const handleAddGroup = async () => {
    if (!selectedAdminClass) return alert('Please select a class first');
    const groupName = prompt('Enter group name:');
    if (!groupName || groupName.trim() === '') return;
    try {
      const response = await axios.post('/api/groups', {
        classId: selectedAdminClass,
        groupName: groupName.trim()
      });
      if (response.data.success) {
        setGroupCreateMessage(`✅ Group "${response.data.groupName}" created!`);
        const groupsResponse = await axios.get(`/api/groups/${selectedAdminClass}`);
        setGroups(groupsResponse.data);
        setTimeout(() => setGroupCreateMessage(''), 3000);
        fetchLeaderboards();
      }
    } catch (err) {
      alert('Failed to create group: ' + (err.response?.data?.error || err.message));
    }
  };

  // Class Management Functions
  const handleAddClass = async () => {
    if (!classForm.name.trim()) {
      alert('Class name is required');
      return;
    }
    const accessCode = classForm.accessCode.trim() || `${classForm.name.trim()}2025`;
    try {
      const response = await axios.post('/api/classes', {
        name: classForm.name.trim(),
        accessCode: accessCode
      });
      if (response.data.success) {
        alert('✅ Class created successfully!');
        setClassForm({ name: '', accessCode: '' });
        setShowClassModal(false);
        axios.get('/api/classes').then(response => setClasses(response.data));
        fetchLeaderboards();
      }
    } catch (err) {
      alert('Failed to create class: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleEditClass = (cls) => {
    setEditingClassId(cls.id);
    setClassForm({ name: cls.name, accessCode: cls.access_code });
    setShowClassModal(true);
  };

  const handleUpdateClass = async () => {
    if (!classForm.name.trim()) {
      alert('Class name is required');
      return;
    }
    try {
      const response = await axios.put(`/api/classes/${editingClassId}`, {
        name: classForm.name.trim(),
        accessCode: classForm.accessCode.trim()
      });
      if (response.data.success) {
        alert('✅ Class updated successfully!');
        setClassForm({ name: '', accessCode: '' });
        setEditingClassId(null);
        setShowClassModal(false);
        axios.get('/api/classes').then(response => setClasses(response.data));
        fetchLeaderboards();
      }
    } catch (err) {
      alert('Failed to update class: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleDeleteClass = async (classId, className) => {
    if (!window.confirm(`Are you sure you want to delete class "${className}"? This cannot be undone.`)) {
      return;
    }
    try {
      await axios.delete(`/api/classes/${classId}`);
      alert('✅ Class deleted successfully!');
      axios.get('/api/classes').then(response => setClasses(response.data));
      fetchLeaderboards();
    } catch (err) {
      alert('Failed to delete class: ' + (err.response?.data?.error || err.message));
    }
  };

  // CSV Import Functions
  const handleCsvFile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCsvFile(file);
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const requiredFields = ['name', 'class', 'group'];
          const hasRequiredFields = requiredFields.every(field => 
            results.meta.fields.includes(field)
          );
          if (!hasRequiredFields) {
            alert('CSV must contain columns: name, class, group');
            return;
          }
          setCsvData(results.data);
        },
        error: (error) => {
          alert('Error parsing CSV: ' + error.message);
        }
      });
    }
  };

  const handleImportCsv = async () => {
    if (csvData.length === 0) {
      alert('No valid data to import');
      return;
    }
    try {
      const response = await axios.post('/api/import-students-csv', {
        students: csvData
      });
      if (response.data.success) {
        alert(`✅ ${response.data.successCount} students imported successfully!`);
        if (response.data.errorCount > 0) {
          alert(`${response.data.errorCount} records failed to import.`);
        }
        setCsvData([]);
        setCsvFile(null);
        // ✅ Force refresh of classes
        axios.get('/api/classes').then(response => setClasses(response.data));
        fetchLeaderboards();
      }
    } catch (err) {
      alert('Failed to import CSV: ' + (err.response?.data?.error || err.message));
    }
  };

  // Bulk Score Functions
  const handleBulkScoreClassChange = async (classId) => {
    setSelectedBulkClass(classId);
    setBulkStudents([]);
    setBulkScores([]);
    try {
      const groupsResponse = await axios.get(`/api/groups/${classId}`);
      const allStudents = [];
      for (const group of groupsResponse.data) {
        const studentsResponse = await axios.get(`/api/students/${group.id}`);
        allStudents.push(...studentsResponse.data.map(student => ({
          ...student,
          groupName: group.name
        })));
      }
      setBulkStudents(allStudents);
 
      // ✅ NEW: Fetch existing scores for the current class and date (if any)
      let existingScores = {};
      if (bulkDate) { // Only fetch if a date is already selected
        const scoresResponse = await axios.get(`/api/scores/${classId}/${bulkDate}`);
        existingScores = scoresResponse.data.reduce((acc, score) => {
          acc[score.id] = score; // Map student ID to their score object
          return acc;
        }, {});
      }

    // ✅ Initialize bulkScores with existing data or defaults
      const initialScores = allStudents.map(student => {
        const existing = existingScores[student.id];
        return {
          studentId: student.id,
          studentName: student.name,
          groupName: student.groupName,
          noise_level: existing ? existing.noise_level : 5,
          equipment_care: existing ? existing.equipment_care : 5,
          teamwork: existing ? existing.teamwork : 5,
          task_completion: existing ? existing.task_completion : 5,
          bonus: existing ? existing.bonus : 0,
          is_absent: existing ? existing.is_absent : false
        };
      });

      setBulkScores(initialScores);

    } catch (error) {
      console.error("Error fetching class students:", error);
      alert('Failed to load students for this class');
    }
  };
  const handleBulkDateChange = async (date) => {
    setBulkDate(date);
    if (selectedBulkClass && date) {
      // Re-fetch scores for the new date
      const groupsResponse = await axios.get(`/api/groups/${selectedBulkClass}`);
      const allStudents = [];
      for (const group of groupsResponse.data) {
        const studentsResponse = await axios.get(`/api/students/${group.id}`);
        allStudents.push(...studentsResponse.data.map(student => ({
          ...student,
          groupName: group.name
        })));
      }

      // ✅ Fetch existing scores for the selected date
      let existingScores = {};
      const scoresResponse = await axios.get(`/api/scores/${selectedBulkClass}/${date}`);
      existingScores = scoresResponse.data.reduce((acc, score) => {
        acc[score.id] = score;
        return acc;
      }, {});

      // ✅ Update bulkScores with existing data
      const updatedScores = allStudents.map(student => {
        const existing = existingScores[student.id];
        return {
          studentId: student.id,
          studentName: student.name,
          groupName: student.groupName,
          noise_level: existing ? existing.noise_level : 5,
          equipment_care: existing ? existing.equipment_care : 5,
          teamwork: existing ? existing.teamwork : 5,
          task_completion: existing ? existing.task_completion : 5,
          bonus: existing ? existing.bonus : 0,
          is_absent: existing ? existing.is_absent : false
        };
      });

      setBulkScores(updatedScores);
    }
  };

  const handleBulkScoreChange = (studentId, field, value) => {
    setBulkScores(prev => 
      prev.map(score => 
        score.studentId === studentId 
          ? { 
              ...score, 
              [field]: field === 'is_absent' ? value : parseInt(value) || 0 // ✅ Handle is_absent
            }
          : score
      )
    );
  };

  const handleSaveBulkScores = async () => {
    if (bulkScores.length === 0) {
      alert('No students to score');
      return;
    }
    try {
      const response = await axios.post('/api/bulk-scores', {
        scores: bulkScores,
        date: bulkDate || new Date().toISOString().split('T')[0]
      });
      if (response.data.success) {
        alert(`✅ ${response.data.successCount} scores saved successfully!`);
        setShowBulkScoreModal(false);
        setBulkScores([]);
        setBulkDate('');
        setSelectedBulkClass('');
        fetchLeaderboards();
      }
    } catch (err) {
      alert('Failed to save bulk scores: ' + (err.response?.data?.error || err.message));
    }
  };

  // Edit group name
  const startEditGroup = (groupId, currentName) => {
    setEditingGroupId(groupId);
    setEditingGroupName(currentName);
  };

  const saveEditGroup = async () => {
    if (!editingGroupName.trim()) {
      alert('Group name cannot be empty');
      return;
    }
    try {
      const response = await axios.put(`/api/groups/${editingGroupId}`, {
        name: editingGroupName.trim()
      });
      if (response.data.success) {
        alert('✅ Group name updated successfully!');
        setEditingGroupId(null);
        setEditingGroupName('');
        if (selectedAdminClass) {
          const groupsResponse = await axios.get(`/api/groups/${selectedAdminClass}`);
          setGroups(groupsResponse.data);
        }
        fetchLeaderboards();
      }
    } catch (err) {
      alert('Failed to update group name: ' + (err.response?.data?.error || err.message));
    }
  };
    
  // Edit student name
  const startEditStudent = (studentId, currentName) => {
    setEditingStudentId(studentId);
    setEditingStudentName(currentName);
  };

  const saveEditStudent = async () => {
    if (!editingStudentName.trim()) {
      alert('Student name cannot be empty');
      return;
    }
    try {
      const response = await axios.put(`/api/students/${editingStudentId}`, {
        name: editingStudentName.trim()
      });
      if (response.data.success) {
        alert('✅ Student name updated successfully!');
        setEditingStudentId(null);
        setEditingStudentName('');
        if (selectedGroup) {
          fetchStudents(selectedGroup);
        }
        fetchLeaderboards();
      }
    } catch (err) {
      alert('Failed to update student name: ' + (err.response?.data?.error || err.message));
    }
  };

  // Delete a student
  const deleteStudent = async (studentId, studentName) => {
    if (!window.confirm(`Are you sure you want to delete student "${studentName}"? This cannot be undone.`)) {
      return;
    }
    try {
      await axios.delete(`/api/students/${studentId}`);
      alert('✅ Student deleted successfully!');
      if (selectedGroup) {
        fetchStudents(selectedGroup);
      }
      if (selectedAdminClass) {
        const groupsResponse = await axios.get(`/api/groups/${selectedAdminClass}`);
        setGroups(groupsResponse.data);
      }
      fetchLeaderboards();
    } catch (err) {
      alert('Failed to delete student: ' + (err.response?.data?.error || err.message));
    }
  };

  // Delete a group
  const deleteGroup = async (groupId, groupName) => {
    if (!window.confirm(`Are you sure you want to delete group "${groupName}" and ALL its students? This cannot be undone.`)) {
      return;
    }
    try {
      await axios.delete(`/api/groups/${groupId}`);
      alert('✅ Group and all students deleted successfully!');
      if (selectedAdminClass) {
        const groupsResponse = await axios.get(`/api/groups/${selectedAdminClass}`);
        setGroups(groupsResponse.data);
      }
      setStudents([]);
      setSelectedStudentId('');
      fetchLeaderboards();
    } catch (err) {
      alert('Failed to delete group: ' + (err.response?.data?.error || err.message));
    }
  };

  // Quick scoring functions
  const quickScoreGroup = (scoreRange) => {
    if (!selectedGroup) {
      alert('Please select a group first');
      return;
    }
    const confirm = window.confirm(`Are you sure you want to score ALL students in this group as ${scoreRange}?`);
    if (!confirm) return;
    const scores = {
      'excellent': { noise_level: 5, equipment_care: 5, teamwork: 5, task_completion: 5, bonus: 2 },
      'good': { noise_level: 4, equipment_care: 4, teamwork: 4, task_completion: 4, bonus: 0 },
      'fair': { noise_level: 3, equipment_care: 3, teamwork: 3, task_completion: 3, bonus: 0 },
      'needs_work': { noise_level: 2, equipment_care: 2, teamwork: 2, task_completion: 2, bonus: 0 }
    };
    axios.get(`/api/students/${selectedGroup}`)
      .then(response => {
        const students = response.data;
        let successCount = 0;
        students.forEach(student => {
          axios.post('/api/scores', {
            studentId: student.id,
            ...scores[scoreRange],
            sessionType: 'double',
            date: new Date().toISOString().split('T')[0]
          })
          .then(() => {
            successCount++;
            if (successCount === students.length) {
              alert(`✅ Scored ${students.length} students with ${scoreRange} score`);
              if (selectedAdminClass) {
                axios.get(`/api/groups/${selectedAdminClass}`).then(res => setGroups(res.data));
              }
              fetchLeaderboards();
            }
          })
          .catch(err => {
            alert('Failed to score student: ' + (err.response?.data?.error || err.message));
          });
        });
      })
      .catch(error => {
        alert('Failed to fetch students: ' + error.message);
      });
  };

  // Move Student Functions
  const loadMoveGroups = async (classId) => {
    try {
      const response = await axios.get(`/api/groups/${classId}`);
      setAvailableMoveGroups(response.data);
      setNewMoveGroup('');
    } catch (error) {
      console.error("Error loading groups for move:", error);
      setAvailableMoveGroups([]);
    }
  };

  const handleMoveStudent = async () => {
    if (!newMoveGroup) {
      alert('Please select a new group');
      return;
    }
    try {
      const response = await axios.post(`/api/students/${studentToMove.id}/move`, {
        newGroupId: newMoveGroup
      });
      if (response.data.success) {
        alert('✅ Student moved successfully!');
        setShowMoveStudentModal(false);
        setStudentToMove(null);
        setNewMoveClass('');
        setNewMoveGroup('');
        setAvailableMoveGroups([]);
        if (selectedAdminClass) {
          const groupsResponse = await axios.get(`/api/groups/${selectedAdminClass}`);
          setGroups(groupsResponse.data);
        }
        fetchLeaderboards();
      }
    } catch (err) {
      alert('Failed to move student: ' + (err.response?.data?.error || err.message));
    }
  };

  const calculateTotalScore = (student) => {
    if (!student) return 0;
    return (student.noise_level || 0) + 
          (student.equipment_care || 0) + 
          (student.teamwork || 0) + 
          (student.task_completion || 0) + 
          (student.bonus || 0);
  };

  const getPositionBadge = (position) => {
    if (position === 1) return '🥇';
    if (position === 2) return '🥈';
    if (position === 3) return '🥉';
    return position;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Animated Header with Logo */}
      <header className="bg-gradient-to-r from-indigo-700 via-purple-600 to-pink-500 text-white shadow-xl relative overflow-hidden">
        {/* Animated background elements */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-24 h-24 bg-yellow-300 rounded-full animate-bounce"></div>
          <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-blue-300 rounded-full animate-ping"></div>
        </div>
        
        <div className="container mx-auto px-4 py-10 text-center relative z-10">
          <div className="flex flex-col items-center justify-center space-y-5 animate-fadeIn">
            {/* School Logo */}
            <div className="bg-white/20 p-3 rounded-2xl backdrop-blur-sm">
              <img 
                src="/logo.png" 
                alt="School Logo" 
                className="h-16 w-16 md:h-20 md:w-20 object-contain drop-shadow-lg"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              {/* Fallback icon if logo missing */}
              <div className="hidden">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-yellow-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
            </div>
            {/* Main Title */}
            <div className="space-y-2">
              <h1 className="text-3xl md:text-5xl font-extrabold drop-shadow-lg bg-clip-text text-transparent bg-gradient-to-r from-yellow-200 via-yellow-300 to-yellow-400 animate-fadeIn">
                🏆 STEM Lab Champions! 🚀
              </h1>
              <p className="text-lg md:text-xl max-w-3xl mx-auto px-4 opacity-90 animate-fadeIn delay-100">
                <span className="font-bold text-yellow-100">Lead your class</span> • <span className="font-bold text-blue-100">Earn robot points</span> • <span className="font-bold text-pink-100">Unlock achievement badges!</span>
              </p>
            </div>
            {/* Admin Login Button */}
            {!isLoggedIn && (
              <button 
                onClick={() => setShowAdminLogin(true)}
                className="mt-4 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white px-6 py-3 rounded-full font-bold flex items-center space-x-2 transition-all duration-300 transform hover:scale-105 border border-white/30 animate-fadeIn delay-200"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 005 10a6 6 0 0012 0c0-.35-.03-.693-.084-1.024A5 5 0 0010 11z" clipRule="evenodd" />
                </svg>
                <span>Teacher Login</span>
              </button>
            )}
            {isLoggedIn && (
              <button 
                onClick={() => {
                  setIsLoggedIn(false);
                  setShowAdminDashboard(false);
                  setActiveView('leaderboard');
                  setIsPublicMode(false);
                  localStorage.removeItem('adminLoggedIn'); // ✅ Clear persistent state
                }}
                className="mt-4 bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-full font-bold flex items-center space-x-2 transition-all duration-300 transform hover:scale-105 animate-fadeIn delay-200"
              >
                <span>Logout</span>
              </button>
            )}
            {isPublicMode && (
              <button 
                onClick={() => {
                  setActiveView('leaderboard');
                  setIsPublicMode(false);
                  setSelectedClass(null);
                  setShowGroups(false);
                }}
                className="ml-4 text-blue-600 hover:text-blue-800"
              >
                ← Back to Leaderboard
              </button>
            )}
          </div>
        </div>
        {fullMarkAchievers.length > 0 && (
        <div className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white py-2 overflow-hidden">
          <div className="animate-scroll whitespace-nowrap">
            {fullMarkAchievers.map((a, i) => (
              <span key={i} className="mx-4 inline-block">
                🎉 <strong>{a.student_name}</strong> from <strong>{a.class_name}-{a.group_name}</strong> scored 22/22!
              </span>
            ))}
          </div>
        </div>
      )}
      </header>
      <main className="container mx-auto px-4 py-8">
        {/* Leaderboard Tabs */}
        {activeView === 'leaderboard' && (
          <div className="animate-fadeIn">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-800">Leaderboards</h2>
              <div className="flex space-x-2">
                <button
                  className={`px-4 py-2 rounded-lg font-medium ${
                    activeLeaderboardTab === 'class' 
                      ? 'bg-indigo-600 text-white' 
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  }`}
                  onClick={() => setActiveLeaderboardTab('class')}
                >
                  Class
                </button>
                <button
                  className={`px-4 py-2 rounded-lg font-medium ${
                    activeLeaderboardTab === 'group' 
                      ? 'bg-indigo-600 text-white' 
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  }`}
                  onClick={() => setActiveLeaderboardTab('group')}
                >
                  Group
                </button>
                <button
                  className={`px-4 py-2 rounded-lg font-medium ${
                    activeLeaderboardTab === 'student' 
                      ? 'bg-indigo-600 text-white' 
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  }`}
                  onClick={() => setActiveLeaderboardTab('student')}
                >
                  Student
                </button>
              </div>
            </div>
            {/* Class Leaderboard */}
            {activeLeaderboardTab === 'class' && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {classLeaderboard.map((cls, index) => {
                  const today = new Date();
                  const startOfWeek = new Date(today);
                  startOfWeek.setDate(today.getDate() - ((today.getDay() + 6) % 7)); // Sunday
                  startOfWeek.setHours(0, 0, 0, 0);
                  const endOfWeek = new Date(startOfWeek);
                  endOfWeek.setDate(endOfWeek.getDate() + 4); // Thursday
                  endOfWeek.setHours(23, 59, 59, 999);
                  const isWeekActive = today >= startOfWeek && today <= endOfWeek;
                  const hasScoredThisWeek = cls.weekly_sessions > 0;
                  return (
                    <div 
                      key={cls.id} 
                      className={`bg-white rounded-xl shadow-lg overflow-hidden border-4 transform transition-all duration-300 hover:shadow-xl hover:-translate-y-2 cursor-pointer ${
                        cls.position <= 3 ? 'border-yellow-400 ring-4 ring-yellow-200' : 'border-gray-200'
                      }`}
                      onClick={() => handleClassClick(cls)}
                    >
                      <div className="p-8">
                        <div className="flex justify-between items-start">
                          <div>
                            <div className="flex items-center mb-3">
                              <span className="bg-yellow-100 text-yellow-800 text-sm font-bold px-3 py-1 rounded-full mr-3">
                                {cls.position_badge}
                              </span>
                              <h3 className="text-3xl font-extrabold text-gray-800">{cls.name}</h3>
                            </div>
                            <div className="space-y-3 mt-4">
                              <div className="flex justify-between">
                                <span className="text-gray-600 text-lg">Avg Score:</span>
                                <span className="font-bold text-green-600 text-xl">
                                  {cls.average_score ? cls.average_score.toFixed(1) : '0.0'}
                                </span>
                              </div>
                              <div className="flex justify-between">
                                <span className="text-gray-600 text-lg">Avg Noise:</span>
                                <span className="font-bold text-blue-600 text-xl">
                                  {(cls.avg_noise_level || 0).toFixed(1)}
                                </span>
                              </div>
                              <div className="flex justify-between">
                                <span className="text-gray-600 text-lg">Students:</span>
                                <span className="font-bold text-gray-800 text-xl">{cls.student_count}</span>
                              </div>
                              <div className="flex justify-between">
                                <span className="text-gray-600 text-lg">Weekly Score:</span>
                                <span className="font-bold text-blue-600 text-xl">{cls.weekly_score}</span>
                              </div>
                              <div className="flex justify-between">
                                <span className="text-gray-600 text-lg">Total Score:</span>
                                <span className="font-bold text-gray-800 text-xl">{cls.total_score}</span>
                              </div>
                            </div>
                          </div>
                          <div className={`rounded-full w-16 h-16 flex items-center justify-center font-bold text-xl ${
                            cls.position <= 3 ? 'bg-yellow-100 text-yellow-800' : 'bg-indigo-100 text-indigo-800'
                          }`}>
                            {cls.position}
                          </div>
                        </div>
                        <div className="mt-6">
                          <div className="w-full bg-gray-200 rounded-full h-4">
                            <div 
                              className="bg-gradient-to-r from-blue-500 to-purple-600 h-4 rounded-full" 
                              style={{ width: `${Math.min(100, (cls.average_score / 22) * 100)}%` }}
                            ></div>
                          </div>
                          <p className="text-xs text-gray-500 mt-2 text-center">
                            Avg Score Progress (Max: 22)
                          </p>
                        </div>
                        {hasScoredThisWeek && (
                          <div className="mt-4 bg-green-100 text-green-800 text-sm font-medium px-4 py-2 rounded-full inline-block">
                            ✅ Scored This Week
                          </div>
                        )}
                        <button 
                          className={`mt-6 w-full py-3 rounded-lg font-bold text-lg transition-colors duration-300 ${
                            !isWeekActive || hasScoredThisWeek
                              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                              : 'bg-indigo-600 text-white hover:bg-indigo-700'
                          }`}
                          disabled={!isWeekActive || hasScoredThisWeek}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (isWeekActive && !hasScoredThisWeek) {
                              handleClassClick(cls);
                            }
                          }}
                        >
                          {isWeekActive && !hasScoredThisWeek ? 'Enter Scores' : 'Scores Locked'}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {/* Group Leaderboard */}
            {activeLeaderboardTab === 'group' && (
              <div className="bg-white rounded-xl shadow-md overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Position</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Group</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Students</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Avg Score</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {groupLeaderboard.map((group) => (
                        <tr key={group.id} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                              group.position === 1 ? 'bg-yellow-100 text-yellow-800' :
                              group.position === 2 ? 'bg-gray-100 text-gray-800' :
                              group.position === 3 ? 'bg-amber-100 text-amber-800' :
                              'bg-blue-100 text-blue-800'
                            }`}>
                              {group.position_badge}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">
                            {group.class_name}-{group.name}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-gray-700">{group.student_count}</td>
                          <td className="px-6 py-4 whitespace-nowrap font-bold text-green-600">
                            {group.average_score ? group.average_score.toFixed(1) : '0.0'}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-gray-700">{group.total_score}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            {/* Student Leaderboard */}
            {activeLeaderboardTab === 'student' && (
              <div className="bg-white rounded-xl shadow-md overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Position</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Student</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Group</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Class</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total Score</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sessions</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {studentLeaderboard.map((student) => (
                        <tr key={`${student.student_name}-${student.class_name}`} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                              student.position === 1 ? 'bg-yellow-100 text-yellow-800' :
                              student.position === 2 ? 'bg-gray-100 text-gray-800' :
                              student.position === 3 ? 'bg-amber-100 text-amber-800' :
                              'bg-blue-100 text-blue-800'
                            }`}>
                              {student.position_badge}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">{student.student_name}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-gray-700">{student.group_name}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-gray-700">{student.class_name}</td>
                          <td className="px-6 py-4 whitespace-nowrap font-bold text-gray-900">{student.total_score}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-gray-700">{student.session_count}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-4">
              <h3 className="font-bold text-blue-800 mb-2">📅 Weekly Lab Schedule</h3>
              <p className="text-blue-700 text-sm">
                Each class has <strong>3 lab sessions per week</strong> (1 double period + 2 single periods). 
                Scores are tracked weekly for monthly prizes!
              </p>
            </div>
          </div>
        )}
        {/* Group Leaderboard */}
        {activeView === 'groups' && showGroups && selectedClass && (
          <div className="mt-8 animate-fadeIn">
            <div className="flex items-center mb-6">
              <button 
                onClick={() => {
                  setActiveView('leaderboard');
                  setShowGroups(false);
                  setSelectedClass(null);
                  setIsPublicMode(false);
                }}
                className="mr-4 text-indigo-600 hover:text-indigo-800"
              >
                ← Back to Classes
              </button>
              <h2 className="text-2xl font-bold text-gray-800">Class {selectedClass.name} Groups</h2>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6">
              <div className="space-y-4">
                {groups.map((group, index) => (
                  <div 
                    key={group.id} 
                    className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
                    onClick={() => {
                      fetchStudents(group.id);
                      setActiveView('students');
                    }}
                  >
                    <div className="flex justify-between items-center">
                      <div className="flex items-center">
                        <div className="bg-indigo-100 text-indigo-800 rounded-full w-8 h-8 flex items-center justify-center font-bold mr-3">
                          {group.position || index + 1}
                        </div>
                        <div>
                          <h4 className="font-bold text-gray-800">{group.name}</h4>
                          <p className="text-gray-600 text-sm">{group.studentCount} students</p>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="font-bold text-gray-800">
                          {group.average_score ? group.average_score.toFixed(1) : '0.0'}/22
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {/* Student Scores */}
        {activeView === 'students' && students.length > 0 && (
          <div className="mt-8 animate-fadeIn">
            <div className="flex items-center mb-6">
              <button 
                onClick={() => {
                  setActiveView('groups');
                  setStudents([]);
                  setSelectedStudentId('');
                }}
                className="mr-4 text-indigo-600 hover:text-indigo-800"
              >
                ← Back to Groups
              </button>
              <h2 className="text-2xl font-bold text-gray-800">
                Group {groups.find(g => g.id === selectedGroup)?.name || ''} Students
              </h2>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Position</th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Student</th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Badges</th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {students.map((student, index) => {
                      // ✅ Ensure all values are numbers before adding
                      const total = (parseInt(student.noise_level) || 0) + 
                                    (parseInt(student.equipment_care) || 0) + 
                                    (parseInt(student.teamwork) || 0) + 
                                    (parseInt(student.task_completion) || 0) + 
                                    (parseInt(student.bonus) || 0);
                      return (
                        <tr 
                          key={student.id} 
                          className="hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
                          onClick={() => setSelectedStudentId(student.id)}
                        >
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                            index === 0 ? 'bg-yellow-100 text-yellow-800' :
                            index === 1 ? 'bg-gray-100 text-gray-800' :
                            index === 2 ? 'bg-amber-100 text-amber-800' :
                            'bg-blue-100 text-blue-800'
                            }`}>
                            {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : index + 1}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">{student.name}</td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex space-x-1">
                            {student.badges.length > 0 ? (
                                student.badges.map((badge, i) => (
                                <span 
                                    key={i}
                                    title={`${badge.name}: ${badge.score}/5`}
                                    className="text-lg cursor-help"
                                >
                                    {badge.icon}
                                </span>
                                ))
                            ) : (
                                <span className="text-gray-400 text-sm">No badges yet</span>
                            )}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap font-bold text-gray-900">
                            {total}/22
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/* Admin Dashboard */}
        {activeView === 'admin' && isLoggedIn && (
          <div className="animate-fadeIn">
            <div className="bg-white rounded-xl shadow-md p-6 mb-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Admin Dashboard</h2>
              <p className="text-gray-600 mb-6">Manage classes, groups, and student scores</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Class Management Section */}
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-5 rounded-xl border border-blue-100">
                  <h3 className="text-lg font-bold text-gray-800 mb-4">Class Management</h3>
                  <button 
                    onClick={() => {
                      setEditingClassId(null);
                      setClassForm({ name: '', accessCode: '' });
                      setShowClassModal(true);
                    }}
                    className="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg font-medium transition-colors duration-300 mb-4"
                  >
                    ➕ Add New Class
                  </button>
                  <div className="space-y-2 max-h-60 overflow-y-auto p-2 border border-gray-300 rounded-md">
                    {classes.length === 0 ? (
                      <p className="text-gray-500 text-sm">No classes available</p>
                    ) : (
                      classes.map(cls => (
                        <div key={cls.id} className="flex items-center justify-between p-2 bg-gray-50 rounded hover:bg-gray-100">
                          <div>
                            <span className="font-medium text-gray-800">{cls.name}</span>
                            <span className="text-gray-600 text-sm ml-2">({cls.access_code})</span>
                          </div>
                          <div className="flex space-x-2">
                            <button
                              onClick={() => handleEditClass(cls)}
                              className="text-blue-600 hover:text-blue-800"
                              title="Edit class"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                              </svg>
                            </button>
                            <button
                              onClick={() => handleDeleteClass(cls.id, cls.name)}
                              className="text-red-600 hover:text-red-800"
                              title="Delete class"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
                {/* Import & Bulk Operations */}
                <div className="bg-gradient-to-br from-purple-50 to-fuchsia-50 p-5 rounded-xl border border-purple-100">
                  <h3 className="text-lg font-bold text-gray-800 mb-4">Import & Bulk Operations</h3>
                  {/* CSV Import */}
                  <div className="mb-4">
                    <h4 className="font-medium text-gray-800 mb-2">Import Students from CSV</h4>
                    <p className="text-gray-600 text-sm mb-2">CSV must have columns: name, class, group</p>
                    <input
                      type="file"
                      accept=".csv"
                      onChange={handleCsvFile}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    />
                    {csvFile && (
                      <button
                        onClick={handleImportCsv}
                        className="mt-2 w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-lg font-medium transition-colors duration-300"
                      >
                        📤 Import CSV
                      </button>
                    )}
                  </div>
                  {/* Bulk Score Entry */}
                  <div>
                    <h4 className="font-medium text-gray-800 mb-2">Bulk Score Entry</h4>
                    <button
                      onClick={() => setShowBulkScoreModal(true)}
                      className="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg font-medium transition-colors duration-300"
                    >
                      📊 Enter Scores in Table
                    </button>
                  </div>
                </div>
                {/* Super Admin Section */}
                {isLoggedIn && (
                  <div className="bg-gradient-to-br from-red-50 to-pink-50 p-5 rounded-xl border border-red-100">
                    <h3 className="text-lg font-bold text-gray-800 mb-4">Super Admin Tools</h3>
                    {!isSuperAdmin ? (
                      <button 
                        onClick={() => setShowSuperAdminLogin(true)}
                        className="w-full bg-red-600 hover:bg-red-700 text-white py-2 rounded-lg font-medium transition-colors duration-300"
                      >
                        🔑 Access Super Admin
                      </button>
                    ) : (
                      <div className="space-y-3">
                        <p className="text-red-700 text-sm">
                          ⚠️ <strong>Warning:</strong> This will delete ALL scores for ALL classes, groups, and students.
                        </p>
                        <button 
                          onClick={async () => {
                            if (window.confirm('🚨 Are you ABSOLUTELY sure you want to RESET ALL SCORES? This cannot be undone!')) {
                              try {
                                const response = await axios.post('/api/super/reset-scores', {
                                  username: 'superadmin',
                                  password: 'reset2025!'
                                });
                                if (response.data.success) {
                                  alert(response.data.message);
                                  fetchLeaderboards(); // Refresh data
                                }
                              } catch (err) {
                                alert('Reset failed: ' + (err.response?.data?.error || err.message));
                              }
                            }
                          }}
                          className="w-full bg-red-700 hover:bg-red-800 text-white py-3 rounded-lg font-bold transition-colors duration-300 animate-pulse"
                        >
                          🧹 RESET ALL SCORES
                        </button>
                        <button 
                          onClick={() => setIsSuperAdmin(false)}
                          className="w-full bg-gray-600 hover:bg-gray-700 text-white py-2 rounded-lg font-medium transition-colors duration-300"
                        >
                          Logout Super Admin
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            {/* Existing Import Students and Enter Scores sections */}
            <div className="bg-white rounded-xl shadow-md p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Import Students Section */}
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-5 rounded-xl border border-blue-100">
                  <h3 className="text-lg font-bold text-gray-800 mb-4">Import Students</h3>
                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Select Class:</label>
                    <select
                      value={selectedAdminClass || ''}
                      onChange={(e) => {
                        setSelectedAdminClass(e.target.value);
                        setSelectedGroup('');
                      }}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    >
                      <option value="">-- Select Class --</option>
                      {classes.map(cls => (
                        <option key={cls.id} value={cls.id}>
                          {cls.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {selectedAdminClass && (
                    <>
                      <button 
                        onClick={handleAddGroup}
                        className="mt-3 w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg font-medium transition-colors duration-300"
                      >
                        ➕ Add Single Group
                      </button>
                      {groupCreateMessage && <p className="text-green-600 text-sm mt-2">{groupCreateMessage}</p>}
                    </>
                  )}
                  {selectedAdminClass && (
                    <div className="form-group mt-3">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Select Group:</label>
                      <div className="space-y-2 max-h-60 overflow-y-auto p-2 border border-gray-300 rounded-md">
                        {groups.length === 0 ? (
                          <p className="text-gray-500 text-sm">No groups in this class</p>
                        ) : (
                          groups.map(group => (
                            <div key={group.id} className="flex items-center justify-between p-2 bg-gray-50 rounded hover:bg-gray-100">
                              <div className="flex items-center">
                                <input
                                  type="radio"
                                  name="selectedGroup"
                                  value={group.id}
                                  checked={selectedGroup === group.id}
                                  onChange={(e) => {
                                    setSelectedGroup(e.target.value);
                                    fetchStudents(e.target.value);
                                  }}
                                  className="mr-3"
                                />
                                {editingGroupId === group.id ? (
                                  <div className="flex items-center space-x-2">
                                    <input
                                      type="text"
                                      value={editingGroupName}
                                      onChange={(e) => setEditingGroupName(e.target.value)}
                                      className="px-2 py-1 border border-gray-300 rounded text-sm"
                                      autoFocus
                                    />
                                    <button
                                      onClick={saveEditGroup}
                                      className="text-green-600 hover:text-green-800"
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                      </svg>
                                    </button>
                                  </div>
                                ) : (
                                  <div className="flex items-center">
                                    <span className="font-medium text-gray-800">{group.name}</span>
                                    <button
                                      onClick={() => startEditGroup(group.id, group.name)}
                                      className="ml-2 text-blue-600 hover:text-blue-800"
                                      title="Edit group name"
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                      </svg>
                                    </button>
                                  </div>
                                )}
                                {group.studentCount > 0 && (
                                  <span className="ml-2 bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                                    {group.studentCount} students
                                  </span>
                                )}
                              </div>
                              <button
                                onClick={() => deleteGroup(group.id, group.name)}
                                className="text-red-600 hover:text-red-800 hover:bg-red-100 p-1 rounded-full"
                                title="Delete group"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                  <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                                </svg>
                              </button>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  )}
                  {selectedGroup && (
                    <div className="form-group mt-3">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Enter Student Names (one per line):</label>
                      <textarea
                        value={studentNamesInput}
                        onChange={(e) => setStudentNamesInput(e.target.value)}
                        placeholder="Alex&#10;Priya&#10;Sam"
                        rows="4"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                      />
                      <button 
                        onClick={handleImportStudents}
                        className="mt-3 w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-lg font-medium transition-colors duration-300"
                      >
                        🚀 Import Students
                      </button>
                      {importMessage && <p className="text-green-600 text-sm mt-2">{importMessage}</p>}
                    </div>
                  )}
                </div>
                {/* Enter Scores Section */}
                <div className="bg-gradient-to-br from-purple-50 to-fuchsia-50 p-5 rounded-xl border border-purple-100">
                  <h3 className="text-lg font-bold text-gray-800 mb-4">Enter Student Scores</h3>
                  <div className="form-group">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Select Class:</label>
                    <select
                      value={selectedAdminClass || ''}
                      onChange={(e) => {
                        setSelectedAdminClass(e.target.value);
                        setSelectedGroup('');
                        setSelectedStudentId('');
                        setStudents([]);
                      }}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    >
                      <option value="">-- Select Class --</option>
                      {classes.map(cls => (
                        <option key={cls.id} value={cls.id}>
                          {cls.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {selectedAdminClass && (
                    <div className="form-group mt-3">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Select Group:</label>
                      <div className="space-y-2 max-h-60 overflow-y-auto p-2 border border-gray-300 rounded-md">
                        {groups.length === 0 ? (
                          <p className="text-gray-500 text-sm">No groups in this class</p>
                        ) : (
                          groups.map(group => (
                            <div key={group.id} className="flex items-center justify-between p-2 bg-gray-50 rounded hover:bg-gray-100">
                              <div className="flex items-center">
                                <input
                                  type="radio"
                                  name="selectedGroup"
                                  value={group.id}
                                  checked={selectedGroup === group.id}
                                  onChange={(e) => {
                                    setSelectedGroup(e.target.value);
                                    fetchStudents(e.target.value);
                                  }}
                                  className="mr-3"
                                />
                                {editingGroupId === group.id ? (
                                  <div className="flex items-center space-x-2">
                                    <input
                                      type="text"
                                      value={editingGroupName}
                                      onChange={(e) => setEditingGroupName(e.target.value)}
                                      className="px-2 py-1 border border-gray-300 rounded text-sm"
                                      autoFocus
                                    />
                                    <button
                                      onClick={saveEditGroup}
                                      className="text-green-600 hover:text-green-800"
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                      </svg>
                                    </button>
                                  </div>
                                ) : (
                                  <div className="flex items-center">
                                    <span className="font-medium text-gray-800">{group.name}</span>
                                    <button
                                      onClick={() => startEditGroup(group.id, group.name)}
                                      className="ml-2 text-blue-600 hover:text-blue-800"
                                      title="Edit group name"
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                      </svg>
                                    </button>
                                  </div>
                                )}
                                {group.studentCount > 0 && (
                                  <span className="ml-2 bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                                    {group.studentCount} students
                                  </span>
                                )}
                              </div>
                              <button
                                onClick={() => deleteGroup(group.id, group.name)}
                                className="text-red-600 hover:text-red-800 hover:bg-red-100 p-1 rounded-full"
                                title="Delete group"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                  <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                                </svg>
                              </button>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  )}
                  {selectedGroup && (
                    <div className="form-group mt-3">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Select Student:</label>
                      <div className="space-y-2 max-h-60 overflow-y-auto p-2 border border-gray-300 rounded-md">
                        {students.length === 0 ? (
                          <p className="text-gray-500 text-sm">No students in this group</p>
                        ) : (
                          students.map(student => (
                            <div key={student.id} className="flex items-center justify-between p-2 bg-gray-50 rounded hover:bg-gray-100">
                              <div className="flex items-center">
                                <input
                                  type="radio"
                                  name="selectedStudent"
                                  value={student.id}
                                  checked={selectedStudentId === student.id}
                                  onChange={(e) => setSelectedStudentId(e.target.value)}
                                  className="mr-3"
                                />
                                {editingStudentId === student.id ? (
                                  <div className="flex items-center space-x-2">
                                    <input
                                      type="text"
                                      value={editingStudentName}
                                      onChange={(e) => setEditingStudentName(e.target.value)}
                                      className="px-2 py-1 border border-gray-300 rounded text-sm"
                                      autoFocus
                                    />
                                    <button
                                      onClick={saveEditStudent}
                                      className="text-green-600 hover:text-green-800"
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                      </svg>
                                    </button>
                                  </div>
                                ) : (
                                  <div className="flex items-center">
                                    <span className="font-medium text-gray-800">{student.name}</span>
                                    <button
                                      onClick={() => startEditStudent(student.id, student.name)}
                                      className="ml-2 text-blue-600 hover:text-blue-800"
                                      title="Edit student name"
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                      </svg>
                                    </button>
                                  </div>
                                )}
                                <button
                                  onClick={() => {
                                    setStudentToMove(student);
                                    setShowMoveStudentModal(true);
                                  }}
                                  className="ml-2 text-purple-600 hover:text-purple-800"
                                  title="Move student to another class/group"
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                  </svg>
                                </button>
                              </div>
                              <button
                                onClick={() => deleteStudent(student.id, student.name)}
                                className="text-red-600 hover:text-red-800 hover:bg-red-100 p-1 rounded-full"
                                title="Delete student"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                  <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                                </svg>
                              </button>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  )}
                  {selectedStudentId && (
                    <>
                      <div className="grid grid-cols-2 gap-3 mt-3">
                        <div className="form-group">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Noise Level (1-5):</label>
                          <input
                            type="number"
                            min="1"
                            max="5"
                            value={scores.noise_level}
                            onChange={(e) => setScores({...scores, noise_level: parseInt(e.target.value) || 5})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                          />
                        </div>
                        <div className="form-group">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Equipment Care (1-5):</label>
                          <input
                            type="number"
                            min="1"
                            max="5"
                            value={scores.equipment_care}
                            onChange={(e) => setScores({...scores, equipment_care: parseInt(e.target.value) || 5})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                          />
                        </div>
                        <div className="form-group">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Teamwork (1-5):</label>
                          <input
                            type="number"
                            min="1"
                            max="5"
                            value={scores.teamwork}
                            onChange={(e) => setScores({...scores, teamwork: parseInt(e.target.value) || 5})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                          />
                        </div>
                        <div className="form-group">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Task Completion (1-5):</label>
                          <input
                            type="number"
                            min="1"
                            max="5"
                            value={scores.task_completion}
                            onChange={(e) => setScores({...scores, task_completion: parseInt(e.target.value) || 5})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                          />
                        </div>
                        <div className="form-group">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Bonus (0 or 2):</label>
                          <input
                            type="number"
                            min="0"
                            max="2"
                            step="2"
                            value={scores.bonus}
                            onChange={(e) => setScores({...scores, bonus: parseInt(e.target.value) || 0})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                          />
                        </div>
                      </div>
                      {/* Session and Date Selection */}
                      <div className="grid grid-cols-2 gap-3 mt-3">
                        <div className="form-group">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Session Type:</label>
                          <select
                            value={sessionType}
                            onChange={(e) => setSessionType(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                          >
                            <option value="double">Double Period</option>
                            <option value="single1">Single Period 1</option>
                            <option value="single2">Single Period 2</option>
                          </select>
                        </div>
                        <div className="form-group">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Date:</label>
                          <input
                            type="date"
                            value={scoreDate}
                            onChange={(e) => setScoreDate(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                          />
                        </div>
                      </div>
                      <button 
                        onClick={handleSaveScore}
                        className="mt-4 w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg font-medium transition-colors duration-300"
                      >
                        💾 Save Score
                      </button>
                      {saveMessage && <p className="text-green-600 text-sm mt-2 text-center">{saveMessage}</p>}
                    </>
                  )}
                  {/* Quick Scoring Mode for Lab Sessions */}
                  <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-4 rounded-lg border border-green-200 mt-4">
                    <h4 className="font-bold text-green-800 mb-2">⚡ Quick Lab Scoring</h4>
                    <p className="text-green-700 text-sm mb-3">
                      Score groups during your lab session (3 sessions per week per class)
                    </p>
                    <div className="grid grid-cols-2 gap-2">
                      <button 
                        onClick={() => quickScoreGroup('excellent')}
                        className="bg-green-600 hover:bg-green-700 text-white py-2 rounded text-sm"
                      >
                        Excellent (18-22 pts)
                      </button>
                      <button 
                        onClick={() => quickScoreGroup('good')}
                        className="bg-yellow-600 hover:bg-yellow-700 text-white py-2 rounded text-sm"
                      >
                        Good (14-17 pts)
                      </button>
                      <button 
                        onClick={() => quickScoreGroup('fair')}
                        className="bg-orange-600 hover:bg-orange-700 text-white py-2 rounded text-sm"
                      >
                        Fair (10-13 pts)
                      </button>
                      <button 
                        onClick={() => quickScoreGroup('needs_work')}
                        className="bg-red-600 hover:bg-red-700 text-white py-2 rounded text-sm"
                      >
                        Needs Work (0-9 pts)
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
      {/* Class Modal */}
      {showClassModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-800">
                {editingClassId ? 'Edit Class' : 'Add New Class'}
              </h3>
              <button 
                onClick={() => setShowClassModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Class Name</label>
                <input
                  type="text"
                  value={classForm.name}
                  onChange={(e) => setClassForm({...classForm, name: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                  placeholder="e.g., 3A"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Access Code</label>
                <input
                  type="text"
                  value={classForm.accessCode}
                  onChange={(e) => setClassForm({...classForm, accessCode: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                  placeholder="e.g., 3A2025 (auto-generated if empty)"
                />
              </div>
            </div>
            <div className="flex justify-end space-x-3 mt-6">
              <button
                type="button"
                onClick={() => setShowClassModal(false)}
                className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={editingClassId ? handleUpdateClass : handleAddClass}
                className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors duration-300"
              >
                {editingClassId ? 'Update' : 'Add'} Class
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Bulk Score Modal */}
      {showBulkScoreModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-6xl max-h-[90vh] overflow-y-auto p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-800">Bulk Score Entry</h3>
              <button 
                onClick={() => setShowBulkScoreModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            {/* Week Info Banner */}
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-4 rounded">
              <p className="text-blue-800 font-medium">
                ⏳ You can only submit scores once per week (Sunday–Thursday).
              </p>
              <p className="text-blue-700 text-sm mt-1">
                Current week: 
                {(() => {
                  const today = new Date();
                  const start = new Date(today);
                  start.setDate(today.getDate() - ((today.getDay() + 6) % 7)); // Sunday
                  const end = new Date(start);
                  end.setDate(end.getDate() + 4); // Thursday
                  return `${start.toLocaleDateString()} – ${end.toLocaleDateString()}`;
                })()}
              </p>
            </div>
            <div className="space-y-4">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Select Class</label>
                <select
                  value={selectedBulkClass}
                  onChange={(e) => handleBulkScoreClassChange(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                >
                  <option value="">-- Select Class --</option>
                  {classes.map(cls => (
                    <option key={cls.id} value={cls.id}>{cls.name}</option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Select Week</label>
                <select
                  value={bulkDate || ''}
                  onChange={(e) => handleBulkDateChange(e.target.value)} // 👈 Use the new function
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                >
                  <option value="">-- Select Week --</option>
                  {Array.from({ length: 4 }, (_, i) => {
                    const weekStart = new Date();
                    weekStart.setDate(weekStart.getDate() - ((weekStart.getDay() + 6) % 7) - i * 7);
                    const weekEnd = new Date(weekStart);
                    weekEnd.setDate(weekEnd.getDate() + 4);
                    return {
                      start: weekStart,
                      end: weekEnd,
                      label: `${weekStart.toLocaleDateString()} – ${weekEnd.toLocaleDateString()}`
                    };
                  }).map((week, index) => (
                    <option key={index} value={week.start.toISOString().split('T')[0]}>
                      {week.label}
                    </option>
                  ))}
                </select>
              </div>
              {/* Delete Scores Button (only if date & class selected) */}
              {bulkDate && selectedBulkClass && (
                <button
                  type="button"
                  onClick={async () => {
                    if (!window.confirm(`⚠️ Delete ALL scores for this class on ${bulkDate}? This cannot be undone.`)) return;
                    try {
                      await axios.delete(`/api/scores/class/${selectedBulkClass}/date/${bulkDate}`);
                      alert('✅ Scores deleted successfully!');
                      // Reset state
                      setBulkScores([]);
                      setBulkStudents([]);
                      setSelectedBulkClass('');
                      setBulkDate('');
                      setShowBulkScoreModal(false);
                      fetchLeaderboards(); // Refresh leaderboards
                    } catch (err) {
                      alert('Failed to delete scores: ' + (err.response?.data?.error || err.message));
                    }
                  }}
                  className="mt-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 text-sm"
                >
                  🗑️ Delete All Scores for This Week
                </button>
              )}
              {bulkStudents.length > 0 && (
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Student</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Group</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Noise (1-5)</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Equipment (1-5)</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Teamwork (1-5)</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Task (1-5)</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Bonus (0/2)</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Absent</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {bulkScores.map((score) => {
                        // ✅ Ensure all values are numbers before adding
                        const total = (parseInt(score.noise_level) || 0) + 
                                      (parseInt(score.equipment_care) || 0) + 
                                      (parseInt(score.teamwork) || 0) + 
                                      (parseInt(score.task_completion) || 0) + 
                                      (parseInt(score.bonus) || 0);
                        return (
                          <tr key={score.studentId}>
                            <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">{score.studentName}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-gray-700">{score.groupName}</td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <input
                                type="number"
                                min="1"
                                max="5"
                                value={score.noise_level}
                                onChange={(e) => handleBulkScoreChange(score.studentId, 'noise_level', e.target.value)}
                                className="w-16 px-2 py-1 border border-gray-300 rounded text-center"
                              />
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <input
                                type="number"
                                min="1"
                                max="5"
                                value={score.equipment_care}
                                onChange={(e) => handleBulkScoreChange(score.studentId, 'equipment_care', e.target.value)}
                                className="w-16 px-2 py-1 border border-gray-300 rounded text-center"
                              />
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <input
                                type="number"
                                min="1"
                                max="5"
                                value={score.teamwork}
                                onChange={(e) => handleBulkScoreChange(score.studentId, 'teamwork', e.target.value)}
                                className="w-16 px-2 py-1 border border-gray-300 rounded text-center"
                              />
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <input
                                type="number"
                                min="1"
                                max="5"
                                value={score.task_completion}
                                onChange={(e) => handleBulkScoreChange(score.studentId, 'task_completion', e.target.value)}
                                className="w-16 px-2 py-1 border border-gray-300 rounded text-center"
                              />
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <select
                                value={score.bonus}
                                onChange={(e) => handleBulkScoreChange(score.studentId, 'bonus', e.target.value)}
                                className="w-16 px-2 py-1 border border-gray-300 rounded text-center"
                              >
                                <option value="0">0</option>
                                <option value="2">2</option>
                              </select>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap font-bold text-gray-900">
                              {total}/22
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <input
                                type="checkbox"
                                checked={score.is_absent}
                                onChange={(e) => handleBulkScoreChange(score.studentId, 'is_absent', e.target.checked)}
                                className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            {bulkStudents.length > 0 && (
              <div className="flex justify-end space-x-3 mt-6">
                <button
                  type="button"
                  onClick={() => setShowBulkScoreModal(false)}
                  className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleSaveBulkScores}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors duration-300"
                >
                  💾 Save All Scores
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {/* Access Code Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-800">Enter Access Code</h3>
              <button 
                onClick={() => setShowModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <p className="text-gray-600 mb-4">Please enter the access code for class <span className="font-bold">{selectedClass?.name}</span></p>
            <form onSubmit={handleAccessSubmit}>
              <div className="mb-4">
                <input
                  type="text"
                  value={accessCode}
                  onChange={(e) => setAccessCode(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  placeholder="e.g. 3A2025"
                  autoFocus
                />
                {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
              </div>
              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors duration-300"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Admin Login Modal */}
      {showAdminLogin && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-800">Admin Login</h3>
              <button 
                onClick={() => setShowAdminLogin(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <form onSubmit={handleAdminLogin}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Username</label>
                <input
                  type="text"
                  value={adminUsername}
                  onChange={(e) => setAdminUsername(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  placeholder="admin"
                  required
                  autoFocus
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                <input
                  type="password"
                  value={adminPassword}
                  onChange={(e) => setAdminPassword(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  placeholder="password123"
                  required
                />
                {adminError && <p className="text-red-500 text-sm mt-2">{adminError}</p>}
              </div>
              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => setShowAdminLogin(false)}
                  className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors duration-300"
                >
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Super Admin Login Modal */}
      {showSuperAdminLogin && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-800">Super Admin Access</h3>
              <button 
                onClick={() => setShowSuperAdminLogin(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <form onSubmit={(e) => {
              e.preventDefault();
              // Verify credentials directly
              if (superUsername === 'superadmin' && superPassword === 'reset2025!') {
                setIsSuperAdmin(true);
                setShowSuperAdminLogin(false);
                setSuperUsername('');
                setSuperPassword('');
                setSuperError('');
              } else {
                setSuperError('Invalid super admin credentials');
              }
            }}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Username</label>
                <input
                  type="text"
                  value={superUsername}
                  onChange={(e) => setSuperUsername(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                  placeholder="superadmin"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                <input
                  type="password"
                  value={superPassword}
                  onChange={(e) => setSuperPassword(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                  placeholder="••••••••"
                  required
                />
                {superError && <p className="text-red-500 text-sm mt-2">{superError}</p>}
              </div>
              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => setShowSuperAdminLogin(false)}
                  className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-300"
                >
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Move Student Modal */}
      {showMoveStudentModal && studentToMove && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-800">Move Student</h3>
              <button 
                onClick={() => {
                  setShowMoveStudentModal(false);
                  setStudentToMove(null);
                  setNewMoveClass('');
                  setNewMoveGroup('');
                  setAvailableMoveGroups([]);
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <p className="mb-4">
              Move <span className="font-bold text-indigo-600">{studentToMove.name}</span> to a new class and group:
            </p>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Select New Class</label>
                <select
                  value={newMoveClass}
                  onChange={(e) => {
                    setNewMoveClass(e.target.value);
                    loadMoveGroups(e.target.value);
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                >
                  <option value="">-- Select Class --</option>
                  {classes.map(cls => (
                    <option key={cls.id} value={cls.id}>{cls.name}</option>
                  ))}
                </select>
              </div>
              {newMoveClass && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Select New Group</label>
                  <select
                    value={newMoveGroup}
                    onChange={(e) => setNewMoveGroup(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                  >
                    <option value="">-- Select Group --</option>
                    {availableMoveGroups.map(group => (
                      <option key={group.id} value={group.id}>{group.name}</option>
                    ))}
                  </select>
                </div>
              )}
            </div>
            <div className="flex justify-end space-x-3 mt-6">
              <button
                type="button"
                onClick={() => {
                  setShowMoveStudentModal(false);
                  setStudentToMove(null);
                }}
                className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleMoveStudent}
                className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors duration-300"
                disabled={!newMoveGroup}
              >
                🔄 Move Student
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Student Badge Detail Modal */}
      {selectedStudentId && students.find(s => s.id === selectedStudentId) && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-800">
                {students.find(s => s.id === selectedStudentId)?.name}'s Badges
              </h3>
              <button 
                onClick={() => setSelectedStudentId('')}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="space-y-4">
              {students.find(s => s.id === selectedStudentId)?.badges.length > 0 ? (
                students.find(s => s.id === selectedStudentId).badges.map((badge, i) => (
                  <div key={i} className="flex items-center p-3 bg-blue-50 rounded-lg">
                    <span className="text-2xl mr-3">{badge.icon}</span>
                    <div>
                      <p className="font-bold text-gray-800">{badge.name}</p>
                      <p className="text-sm text-gray-600">Score: {badge.score}/5</p>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-gray-600 text-center py-4">No badges earned yet. Keep up the good work!</p>
              )}
            </div>
            <div className="mt-6 text-center text-sm text-gray-500">
              Badges are awarded for scoring 4–5 in a category.
            </div>
          </div>
        </div>
      )}
      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-8 mt-16 border-t border-gray-800">
        <div className="container mx-auto px-4 text-center animate-fadeIn">
          <div className="flex flex-col items-center justify-center space-y-3">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-yellow-400 rounded-full animate-pulse"></div>
              <span className="text-lg font-semibold text-white">Created by MC</span>
              <div className="w-3 h-3 bg-blue-400 rounded-full animate-pulse delay-200"></div>
            </div>
            <p className="text-sm max-w-2xl">
              Empowering young innovators through STEM education • BISM STEM Lab Score Tracker
            </p>
            <p className="text-xs text-gray-500 mt-2">
              © {new Date().getFullYear()} STEM Lab Champions • All rights reserved
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;